import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../../common/models/Error";
import { UpsellState } from "../models/UpsellsState";

const setError = (state: UpsellState, action: PayloadAction<Error>) => {
    state.isError = action.payload.error;
    state.isLoading = false;
}

export default setError;